import React from 'react'

const NewSchedule = () => {
    return (
        <div>NewSchedule</div>
    )
}

export default NewSchedule